import React, { Component, Fragment } from "react";
import { getLoggedInUser } from "../../../MainPage/UserInfo";
import { CRUDFunction } from "../../../../reduxCURD/container";
import ConfirmationDialog from "../../../../libraries/ConfirmationDialog";
import { MyButton } from "../../../Common/Forms/formsMiscItems";
import permissionCheck from "../../../../utils/permissionCheck";
import { ToastService } from "../../../../utils/toastify";
import { withRouter } from "react-router-dom";

const user = getLoggedInUser();

class CertifyOOU extends Component {
  constructor(props) {
    super(props);
    this.state = {
      certifiedBy: this.props.certifiedBy,
      confirmationDialog: null,
      denyConfirmationDialog: null,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.actionType !== this.props.actionType && this.props.actionType === "OOUCERTIFYTEST_UPDATE_SUCCESS") {
      ToastService.Success(
        this.props.OOUCertifyTest && this.props.OOUCertifyTest.certifiedBy ? "Certified Successfully" : "Denied Successfully",
      );
      this.props.handleCertifyClick();
    }

    if (prevProps.actionType !== this.props.actionType && this.props.actionType === "OOUCERTIFYTEST_UPDATE_FAILURE") {
      ToastService.Error("Error:", this.props.OOUCertifyTest && this.props.OOUCertifyTest.certifiedBy ? "Certify Error" : "Deny Error");
      this.props.handleCertifyClick();
    }
  }

  certifyOOU = () => {
    const payload = {
      certifiedBy: {
        id: user._id.toString(),
        name: user.name,
        email: user.email,
      },
      periodDetails: this.props.oouPeriodDetails,
      assetId: this.props.assetId,
    };
    this.props.updateOOUCertifyTest(payload, "certifyOOUTest");
    this.closeConfirmationDialog();
  };

  denyOOU = () => {
    const payload = {
      certifiedBy: {
        id: user._id.toString(),
        name: user.name,
        email: user.email,
      },
      periodDetails: this.props.oouPeriodDetails,
      assetId: this.props.assetId,
    };
    this.props.updateOOUCertifyTest(payload, "denyOOUTest");
    this.closeDenyConfirmationDialog();
  };

  openConfirmationDialog = () => {
    this.setState({
      confirmationDialog: (
        <ConfirmationDialog
          title="Confirm"
          body={<Fragment>Are you sure you want to certify?</Fragment>}
          action="oouCertify"
          cancelCallback={this.closeConfirmationDialog}
          confirmationCallback={this.certifyOOU}
        />
      ),
    });
  };

  openDenyConfirmationDialog = () => {
    this.setState({
      denyConfirmationDialog: (
        <ConfirmationDialog
          title="Confirm"
          body={
            <Fragment>
              Are you sure you want to deny certification? <br />
              <br />
              <b>Note:</b> Denied certification entries and their inspection reports will be permanently removed from the system.
            </Fragment>
          }
          action="oouDeny"
          cancelCallback={this.closeDenyConfirmationDialog}
          confirmationCallback={this.denyOOU}
        />
      ),
    });
  };

  closeConfirmationDialog = () => {
    this.setState({ confirmationDialog: null });
  };

  closeDenyConfirmationDialog = () => {
    this.setState({ denyConfirmationDialog: null });
  };

  shouldDisableCertify() {
    return !user.highlyQualified;
  }

  shouldDisableDeny() {
    const allowDeny = permissionCheck("BLUECARD", "deny_certify");
    return !user.highlyQualified || !allowDeny;
  }

  render() {
    const disableCertify = this.shouldDisableCertify();
    return (
      <div>
        {this.state.confirmationDialog}
        {this.state.denyConfirmationDialog}
        {this.state.certifiedBy ? ( // If certified, show "by <name>"
          <span>{this.state.certifiedBy.name ? this.state.certifiedBy.name : this.state.certifiedBy}</span>
        ) : (
          <div>
            <MyButton
              className="no-print blueCardFooterReport"
              style={{
                backgroundColor: "var(--nine)",
                borderRadius: "5px",
                padding: "1px 15px",
                fontSize: "18px",
                marginBottom: "4px",
                marginRight: "5px",
              }}
              onClick={this.openConfirmationDialog}
              disabled={disableCertify}
            >
              Certify
            </MyButton>
            {/* <MyButton
              className="no-print blueCardFooterReport"
              style={{ backgroundColor: "#dc3545", borderRadius: "5px", padding: "1px 15px", fontSize: "18px", marginBottom: "4px" }}
              onClick={this.openDenyConfirmationDialog}
              disabled={this.shouldDisableDeny()}
            >
              Deny Certify
            </MyButton> */}
          </div>
        )}
      </div>
    );
  }
}
let actionOptions = {
  create: false,
  update: true,
  read: true,
  delete: false,
};

const CertifyOOUContainer = CRUDFunction(CertifyOOU, "OOUCertifyTest", actionOptions, null, null, "blueCard");

export default withRouter(CertifyOOUContainer);



// WEBPACK FOOTER //
// ./src/components/BlueCardReport/BlueCardReportView/CertifyTest/CertifyOOU.jsx